import React, { useEffect, useState } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { MenuIcon, XIcon, PhoneIcon } from "lucide-react";
import { Logo } from "./Logo";
import { company, upcomingPages } from "../data/navigation";
const navItems = [{
  path: "/",
  label: "Accueil"
}, ...upcomingPages];
export function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);
  const linkClass = ({
    isActive
  }: {
    isActive: boolean;
  }) => `text-[15px] font-medium transition-colors duration-150 ease-out ${isActive ? "text-lime" : "text-white/85 hover:text-white"}`;
  return <header className="sticky top-0 z-50 w-full border-b border-white/5 bg-ink/95 backdrop-blur" data-id="element-35" data-mp="36d4qn47m5oy2">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-5 md:px-8" data-id="element-36" data-mp="3b81xq5lc1o8b">
        <Logo data-id="element-37" data-mp="3f9ng26gmyupw" />

        <nav aria-label="Navigation principale" className="hidden lg:block" data-id="element-38" data-mp="2wkun6w6r9n7c">
          <ul className="flex items-center gap-9" data-id="element-39" data-mp="2wirnfkfswfpf">
            {navItems.map(item => <li key={item.path} data-id="element-40" data-mp="2rkgfjf92gf9u">
                <NavLink to={item.path} end className={linkClass} data-id="element-41" data-mp="2mmevaqzwm9ws">
                  {item.label}
                </NavLink>
              </li>)}
          </ul>
        </nav>

        <div className="hidden items-center gap-5 lg:flex" data-id="element-42" data-mp="2hpy942c9m5mc">
          <a href={company.phoneHref} className="flex items-center gap-2 whitespace-nowrap text-[15px] font-medium text-white/85 transition-colors duration-150 ease-out hover:text-white" data-id="element-43" data-mp="3fa12084fhunv">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-44" data-mp="35jg1gf572g2b" />
            {company.phone}
          </a>
          <Link to="/contact" className="whitespace-nowrap rounded-full bg-lime px-6 py-3 text-[15px] font-medium text-ink transition-colors duration-150 ease-out hover:bg-lime-hover" data-id="element-45" data-mp="30klmjoaclbnh">
            Devis gratuit
          </Link>
        </div>

        <button type="button" onClick={() => setOpen(v => !v)} className="flex h-11 w-11 items-center justify-center rounded-full text-white hover:bg-white/10 lg:hidden" aria-expanded={open} aria-controls="mobile-menu" aria-label={open ? "Fermer le menu" : "Ouvrir le menu"} data-id="element-46" data-mp="1re349pwrkid8">
          {open ? <XIcon className="h-6 w-6" data-id="element-47" data-mp="18mk4dry1dkff" /> : <MenuIcon className="h-6 w-6" data-id="element-48" data-mp="18mafy8sn3lbu" />}
        </button>
      </div>

      <AnimatePresence data-id="element-49" data-mp="1cp6sbhrl6l7c">
        {open && <motion.nav id="mobile-menu" aria-label="Navigation mobile" initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="border-t border-white/10 bg-ink px-5 pb-6 pt-2 lg:hidden" data-id="element-50" data-mp="1cq010oa3vks4">
            <ul className="flex flex-col" data-id="element-51" data-mp="2y1hxeq5s7x6h">
              {navItems.map(item => <li key={item.path} className="border-b border-white/10" data-id="element-52" data-mp="mfpqc0d0begc">
                  <NavLink to={item.path} end className={({
              isActive
            }) => `block py-4 text-lg font-medium ${isActive ? "text-lime" : "text-white"}`} data-id="element-53" data-mp="hg3ffxkniaap">
                    {item.label}
                  </NavLink>
                </li>)}
            </ul>
            <div className="mt-5 flex flex-col gap-3" data-id="element-54" data-mp="105jiarjt6eua">
              <Link to="/contact" className="rounded-full bg-lime px-6 py-3.5 text-center font-medium text-ink" data-id="element-55" data-mp="1f324bm53qdy1">
                Devis gratuit
              </Link>
              <a href={company.phoneHref} className="flex items-center justify-center gap-2 rounded-full border border-white/25 px-6 py-3.5 font-medium text-white" data-id="element-56" data-mp="3gu6x4lirtkjy">
                <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-57" data-mp="22xm0kpus4ujd" />
                {company.phone}
              </a>
            </div>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}